import {Injectable} from '@angular/core';
import {RedtextService} from '../../../generated-api';
import {catchError, shareReplay} from 'rxjs/operators';
import {RedtextStoreService} from './redtext-store.service';
import {throwError} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RedtextPageService {

  constructor(private redtextService: RedtextService, private detailsStore: RedtextStoreService) {
  }

  getRedtext(id, cb): void {
    this.detailsStore.loading = true;
    this.detailsStore.searchError = null;
    this.detailsStore.selectedRedtext = null;
    this.redtextService.getRedtext(id, 'body', false, {}).pipe(shareReplay(1), catchError(err => {
      this.detailsStore.loading = false;
      this.detailsStore.searchError = err.message;
      this.detailsStore.selectedRedtext = null;
      return throwError(err);
    })).subscribe((value: any) => {
      this.detailsStore.loading = false;
      this.detailsStore.searchError = null;
      this.detailsStore.selectedRedtext = value;
      if (cb) {
        cb(value);
      }
    });
  }

}
